/** `tel:` URL for `phoneNumber`. Spaces are stripped from the URL, never from the label. */
export function telHref(phoneNumber: string): string {
  return `tel:${phoneNumber.replaceAll(' ', '')}`
}

/** `mailto:` URL for `email`. */
export function mailtoHref(email: string): string {
  return `mailto:${email}`
}
